import archive from '../store/archive'
import elements from '../store/elements'
import { isCustomProduct, state } from '../store/state'
import triggers from '../store/triggers'

const options = window.VARIANTS_OPTION_DATA

const updateSizes = (layout) => {
  if (!layout) return
  const sizes = elements.types.length > 0
    ? options[state.type][layout]
    : options[layout]
  const sizeFromArchive = archive.sizes[layout]
  let newSize = null
  let hasSelected = false

  for (const elem of elements.sizes) {
    const size = elem.dataset.avalue
    if (!isCustomProduct) {
      elem.previousElementSibling.checked = false // disable sizes, a user must choose himself, if he didn't it before
    }

    if (sizes[size] !== undefined) {
      elem.parentElement.style.display = 'inline-block'

      // select size from archive or first
      if (
        !hasSelected && (
          sizeFromArchive === size || // if size in archive for default products
          (sizeFromArchive === undefined && isCustomProduct) // if size is first for custom products
        )
      ) {
        // elem.previousElementSibling.checked = true
        newSize = size
        hasSelected = true
      }
    } else {
      elem.parentElement.style.display = 'none'
    }
  }

  if (state.size !== newSize) {
    state.size = newSize
    triggers.emitEvent('state:size', [state.size])
  }
}

const changeSize = size => {
  archive.sizes[state.layout] = size
  for (const label of elements.sizes) {
    if (label.dataset.avalue === size) {
      label.previousElementSibling.checked = true
      break
    }
  }
}

const sizes = () => {
  updateSizes(state.layout)
  changeSize(state.size)
  triggers.on('state:layout', updateSizes)
  triggers.on('state:size', changeSize)
}

export default sizes
